export default {"src":"/_next/static/media/0x40d16fc0246ad3160ccc09b8d0d3a2cd28ae6c2f.b5a6b1dc.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};